export default __webpack_public_path__ + "img/2c56cdf160a3ef8f5f03b61703d87ab0.png";